/**
 * Auto final sale
 * Adds the same "Finalsale: Final sale" line item property used by products tagged 'finalsale'
 * when the selected variant is 40%+ off its compare-at price. Code discounts don't count.
 * The hidden input is rendered by snippets/variant-picker.liquid (only for products NOT tagged finalsale).
 */
(function () {
  if (window.autoFinalSaleLoaded) return;
  window.autoFinalSaleLoaded = true;

  var THRESHOLD = 0.4;

  function isDeepSale(v) {
    return !!(v && v.compare_at_price && v.compare_at_price > v.price &&
      (v.compare_at_price - v.price) / v.compare_at_price >= THRESHOLD);
  }

  // Only inputs that belong to this product block (not nested quick-buy products)
  function inputsFor(root) {
    return Array.prototype.filter.call(root.querySelectorAll('.js-auto-finalsale'), function (input) {
      return input.closest('.js-product') === root;
    });
  }

  // Fallback if the form="" attribute didn't resolve: move the input into the product form
  function ensureInForm(input) {
    if (input.form) return;
    var root = input.closest('.js-product');
    var form = root && root.querySelector('.js-product-form');
    if (form) {
      input.removeAttribute('form');
      form.appendChild(input);
    }
  }

  function init() {
    document.querySelectorAll('.js-auto-finalsale').forEach(ensureInForm);
  }

  document.addEventListener('on:variant:change', function (evt) {
    var root = evt.target && evt.target.closest ? evt.target.closest('.js-product') : null;
    if (!root) return;
    var on = isDeepSale(evt.detail && evt.detail.variant);
    inputsFor(root).forEach(function (input) {
      ensureInForm(input);
      input.disabled = !on;
    });
  });

  document.addEventListener('on:quickbuy:after-open', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();